import React from "react";
import { Row, Col } from "react-bootstrap";
import { processImagePath } from "../../../../util/Functions";

export default function FormBuilderInputAutolookupOption({ props, option }) {
	if (!option) {
		return;
	}

	const imageCol = option.image && (
		<Col className="img-wrapper" flex-grow={0} style={{ flex: 0 }}>
			<img
				loading="lazy"
				width="50"
				src={processImagePath(option.image)}
				style={{ paddingRight: '4px', paddingLeft: 0 }}
				alt=""
			/>
		</Col>
	);
	const parts = [... new Set([option.code, option.name, option.heading, option.description])].filter(Boolean);
	return (
		<Row id={option.id} {...props} flex-grow={0} flex={0} style={{ flexWrap: 'nowrap', margin: 0 }}>
			{imageCol}
			<Col className="details" flex-grow={1} flex-shrink={'unset'} flex={1}>
				<b>{parts[0]}</b> {parts[1]} <br />
				{parts.slice(2).join(", ")}
			</Col>
		</Row>
	);
}
